import { EsDocument } from "@edp-models/ES/es-document.model";
import { Action } from "@ngrx/store";

export enum EDocumentEsActions {
    GetDocumentEs = "[DocumentEs] Get Document ES",
    SetDocumentEs = "[DocumentEs] Set Document ES",
}

export class GetDocumentEs implements Action {
    public readonly type = EDocumentEsActions.GetDocumentEs;
    constructor(public contractId: string) {}
}

export class SetDocumentEs implements Action {
    public readonly type = EDocumentEsActions.SetDocumentEs;
    constructor(public payload: EsDocument[]) {}
}

export type EsDocumentActions = GetDocumentEs | SetDocumentEs;
